















































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  FieldProvenance,
  PrefillPayload
} from "@/services/FormPrefillService";
import {
  BarisDraftReasesmen,
  DraftReasesmenField,
  DraftReasesmenTerapan,
  FisikReasesmenKunci,
  ObatAktifItem,
  PerkembanganCpptItem
} from "@/types/asesmen_awal_ranap_medis";
import {
  JALUR_TTV,
  LABEL_FISIK,
  formatWaktuSumber,
  parseObjektifFisik,
  susunRps,
  susunTerapi
} from "@/utils/reasesmenDraft";

@Component
export default class DraftReasesmenDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ default: null }) readonly payload!: PrefillPayload | null;
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;

  labelFisik = LABEL_FISIK;

  keluhanUtama: BarisDraftReasesmen | null = null;
  rpsAwal: BarisDraftReasesmen | null = null;
  rpd: BarisDraftReasesmen | null = null;
  rpk: BarisDraftReasesmen | null = null;
  diagnosis: BarisDraftReasesmen | null = null;
  terapi: BarisDraftReasesmen | null = null;

  perkembangan: PerkembanganCpptItem[] = [];
  perkembanganDipilih: number[] = [];
  obat: ObatAktifItem[] = [];
  obatDipilih: number[] = [];

  ttvNilai: Partial<Record<DraftReasesmenField, string | number | null>> = {};
  ttvJalur: string[] = [];
  ttvSumber: FieldProvenance | null = null;
  ttvDipilih = false;

  fisik: Partial<Record<FisikReasesmenKunci, string>> = {};
  fisikSisa = "";
  fisikSumber: FieldProvenance | null = null;
  fisikDipilih = false;
  adaObjektif = false;

  get adaCppt(): boolean {
    return !!(
      this.keluhanUtama ||
      this.diagnosis ||
      this.terapi ||
      this.adaObjektif ||
      this.perkembangan.length
    );
  }

  get kunciFisik(): FisikReasesmenKunci[] {
    return (Object.keys(LABEL_FISIK) as FisikReasesmenKunci[]).filter(
      kunci => !!this.fisik[kunci]
    );
  }

  get ringkasanTtv(): string {
    const n = this.ttvNilai;
    const bagian: string[] = [];

    if (n.sistole || n.diastole) {
      bagian.push(`TD ${n.sistole || "-"}/${n.diastole || "-"} mmHg`);
    }
    if (n.nadi) bagian.push(`Nadi ${n.nadi} x/menit`);
    if (n.nafas) bagian.push(`Napas ${n.nafas} x/menit`);
    if (n.suhu) bagian.push(`Suhu ${n.suhu} °C`);
    if (n.saturasiO2) bagian.push(`SpO₂ ${n.saturasiO2}%`);
    if (n.bb) bagian.push(`BB ${n.bb} kg`);
    if (n.tb) bagian.push(`TB ${n.tb} cm`);
    if (n.keadaanUmum) bagian.push(`KU ${n.keadaanUmum}`);

    return bagian.join(" · ");
  }

  get jumlahDipilih(): number {
    return [
      this.keluhanUtama && this.keluhanUtama.dipilih,
      (this.rpsAwal && this.rpsAwal.dipilih) || this.perkembanganDipilih.length,
      this.rpd && this.rpd.dipilih,
      this.rpk && this.rpk.dipilih,
      this.ttvJalur.length && this.ttvDipilih,
      this.kunciFisik.length && this.fisikDipilih,
      this.diagnosis && this.diagnosis.dipilih,
      (this.terapi && this.terapi.dipilih) || this.obatDipilih.length
    ].filter(Boolean).length;
  }

  @Watch("payload", { immediate: true })
  onPayload() {
    this.bangun();
  }

  baris(jalur: string): BarisDraftReasesmen | null {
    const fields = this.payload ? this.payload.fields : {};
    const nilai = fields[jalur];

    if (nilai === null || nilai === undefined || String(nilai).trim() === "") {
      return null;
    }

    return {
      isi: String(nilai),
      jalur,
      sumber: this.sumber(jalur),
      dipilih: true
    };
  }

  sumber(jalur: string): FieldProvenance | null {
    return this.payload && this.payload.provenance
      ? this.payload.provenance[jalur] || null
      : null;
  }

  bangun() {
    const fields = this.payload ? this.payload.fields : {};

    this.keluhanUtama = this.baris("reasesmen.keluhan_utama");
    this.rpsAwal = this.baris("reasesmen.rps_awal");
    this.rpd = this.baris("reasesmen.riwayat_penyakit_dahulu");
    this.rpk = this.baris("reasesmen.riwayat_penyakit_keluarga");
    this.diagnosis = this.baris("reasesmen.diagnosis");
    this.terapi = this.baris("reasesmen.terapi");

    this.perkembangan = Array.isArray(fields["reasesmen.perkembangan_list"])
      ? fields["reasesmen.perkembangan_list"]
      : [];
    this.perkembanganDipilih = [];
    this.obat = Array.isArray(fields["reasesmen.obat_aktif_list"])
      ? fields["reasesmen.obat_aktif_list"]
      : [];
    this.obatDipilih = [];

    const ttvNilai: Partial<Record<DraftReasesmenField, string | number | null>> = {};
    const ttvJalur: string[] = [];
    Object.keys(JALUR_TTV).forEach(jalur => {
      const nilai = fields[jalur];
      if (nilai !== null && nilai !== undefined && String(nilai).trim() !== "") {
        ttvNilai[JALUR_TTV[jalur]] = nilai;
        ttvJalur.push(jalur);
      }
    });
    this.ttvNilai = ttvNilai;
    this.ttvJalur = ttvJalur;
    this.ttvSumber = ttvJalur.length ? this.sumber(ttvJalur[0]) : null;
    this.ttvDipilih = ttvJalur.length > 0;

    const objektif = fields["reasesmen.objective"];
    const hasil = parseObjektifFisik(objektif);
    this.adaObjektif = !!(objektif && String(objektif).trim());
    this.fisik = hasil.fisik;
    this.fisikSisa = hasil.sisa;
    this.fisikSumber = this.sumber("reasesmen.objective");
    this.fisikDipilih = Object.keys(hasil.fisik).length > 0;
  }

  teksSumber(sumber: FieldProvenance | null): string {
    if (!sumber) return "";

    const bagian = [
      sumber.source_label,
      sumber.recorded_by_name,
      formatWaktuSumber(sumber.recorded_at)
    ].filter(Boolean);

    return bagian.length ? `Sumber: ${bagian.join(" · ")}` : "";
  }

  tutup() {
    this.$emit("input", false);
    this.$emit("batal");
  }

  terapkan() {
    const nilai: Partial<Record<DraftReasesmenField, string | number | null>> = {};
    const jalur: string[] = [];

    const ambil = (
      baris: BarisDraftReasesmen | null,
      kunci: DraftReasesmenField
    ) => {
      if (baris && baris.dipilih) {
        nilai[kunci] = baris.isi;
        jalur.push(baris.jalur);
      }
    };

    ambil(this.keluhanUtama, "keluhanUtama");
    ambil(this.rpd, "riwayatPenyakitDahulu");
    ambil(this.rpk, "riwayatPenyakitKeluarga");
    ambil(this.diagnosis, "diagnosis");

    const perkembanganTerpilih = this.perkembangan.filter(item =>
      this.perkembanganDipilih.includes(item.soap_id)
    );
    const pakaiRpsAwal = !!(this.rpsAwal && this.rpsAwal.dipilih);
    if (pakaiRpsAwal || perkembanganTerpilih.length) {
      nilai.riwayatPenyakitSekarang = susunRps(
        pakaiRpsAwal && this.rpsAwal ? this.rpsAwal.isi : null,
        perkembanganTerpilih
      );
      if (pakaiRpsAwal) jalur.push("reasesmen.rps_awal");
      if (perkembanganTerpilih.length) jalur.push("reasesmen.perkembangan_list");
    }

    if (this.ttvJalur.length && this.ttvDipilih) {
      Object.assign(nilai, this.ttvNilai);
      jalur.push(...this.ttvJalur);
    }

    if (this.kunciFisik.length && this.fisikDipilih) {
      this.kunciFisik.forEach(kunci => {
        nilai[kunci] = this.fisik[kunci] || "";
      });
      jalur.push("reasesmen.objective");
    }

    const obatTerpilih = this.obat.filter(item =>
      this.obatDipilih.includes(item.cpo_item_id)
    );
    const pakaiTerapi = !!(this.terapi && this.terapi.dipilih);
    if (pakaiTerapi || obatTerpilih.length) {
      nilai.terapi = susunTerapi(
        pakaiTerapi && this.terapi ? this.terapi.isi : null,
        obatTerpilih
      );
      if (pakaiTerapi) jalur.push("reasesmen.terapi");
      if (obatTerpilih.length) jalur.push("reasesmen.obat_aktif_list");
    }

    const hasil: DraftReasesmenTerapan = { nilai, jalur };
    this.$emit("terapkan", hasil);
    this.$emit("input", false);
  }
}
